import React from "react";
import { Grid, Button, withStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { BrandColors } from "../../../../styles/BrandColors";
import styles from "./styles";

const PrimaryButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(BrandColors.JLLBrandColors.Red.core),
    backgroundColor: BrandColors.JLLBrandColors.Red.core,
    "&:hover": {
      backgroundColor: BrandColors.JLLBrandColors.Red.tint75Percent,
    },
  },
}))(Button);

const SecondaryButton = withStyles((theme) => ({}))(Button);

const DisabledButton = withStyles((theme) => ({
  root: {
    color: BrandColors.JLLBrandColors.Concrete.core,
    backgroundColor: BrandColors.JLLBrandColors.Concrete.tint50Percent,
  },
}))(Button);

const StepActions = (props) => {
  const {
    canSkip,
    canBack = true,
    canNext = true,
    canSubmit = false,
    disableNext = false,
    onCancel,
    onNext,
    onBack,
    onSkip,
    onSubmit,
  } = props;
  const { t } = useTranslation();

  const handleNext = (event) => {
    onNext();
  };

  const handleCancel = (event) => {
    onCancel();
  };

  const handleBack = (event) => {
    onBack();
  };

  const handleSkip = (event) => {
    onSkip();
  };

  const handleSubmit = (event) => {
    onSubmit();
  };

  return (
    <Grid container spacing={0} justifyContent="flex-end">
      <SecondaryButton onClick={handleCancel}>
        {t("labels.common.cancel")}
      </SecondaryButton>
      {canBack && (
        <SecondaryButton onClick={handleBack}>
          {t("labels.common.back")}
        </SecondaryButton>
      )}
      {canSkip && (
        <SecondaryButton onClick={handleSkip}>
          {t("labels.common.skip")}
        </SecondaryButton>
      )}
      {canNext && (
        <PrimaryButton onClick={handleNext} disabled={disableNext}>
          {t("labels.common.next")}
        </PrimaryButton>
      )}
      {canSubmit &&
        (disableNext ? (
          <DisabledButton>Verify CAPTCHA</DisabledButton>
        ) : (
          <PrimaryButton onClick={handleSubmit} disabled={disableNext}>
            {t("labels.common.submit")}
          </PrimaryButton>
        ))}
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(StepActions);
